import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

//*MUI
import { Box, Divider, Popover, Typography } from '@mui/material';

//*files
import cssClasses from './EventUnitDetails.module.css';
import UnitIcon from '../../../../Assets/Images/Sustenance/UnitIcon.svg';
import CustomSwitch from '../../../../Subcomponents/CustomSwitch';
import LeadStatusChip from '../../../../Subcomponents/LeadStatusChip';
import Dot from '../../../Icons/Dot';
import Button from '../../../../Subcomponents/Button';
import EditIcon from '../../../../Components/Icons/EditIcon';
import EditUnitInfo from '../../../../Modals/EditUnitInfo/EditUnitInfo';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  getProjectByProjectName,
  getUnitByUnitNo,
  getWingsIdByWingName,
} from '../../../../Services/SustenanceService';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';
import ChangeUnitStatus from '../../../../Modals/ChangeUnitStatus/ChangeUnitStatus';
import { successTost } from '../../../../Services/Toast';
import { ShowBasePrice } from '../../../../Services/Project';
import { getEventByEventName } from '../../../../Services/Event';
import { getAllPricingPlansByLaunch } from '../../../../Services/PaymentPlans';

function EventUnitDetails() {
  let loggedInUser = {};
  const [ChipStyle, setChipStyle] = useState(null);

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [checked, setChecked] = useState(false);
  const { eventID, projectId, wingName, unitNo, launchId } = useParams();

  const navigate = useNavigate();

  const [ProjectData, setProjectData] = useState([]);
  const [AllWings, setAllWings] = useState([]);
  const [Units, setUnits] = useState([]);

  //*Base-Price-Data
  const [mergeIdData, setMergeIdData] = useState(false);
  const [mergeID, setMergeID] = useState('');
  const [Unit1, setUnit1] = useState('');
  const [Unit2, setUnit2] = useState('');
  const [TotalBsp, setTotalBsp] = useState([]);
  const [FloorRiseValue, setFloorRiseValue] = useState(0);
  const [plcValue, setPlcValue] = useState(0);
  const [CsvData, setCsvData] = useState([]);
  const [csvFlag, setCsvFlag] = useState(false);
  const [SalesPersonName, setSalesPersonName] = useState('');
  const [PriceNotAdded, setPriceNotAdded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [afterCancelUnitPrice, setAfterCancelUnitPrice] = useState(false);
  const [liveButton, setLiveButton] = useState(false);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const IconOpen = Boolean(anchorEl);

  const id = open ? 'simple-popover' : undefined;
  const handleIconClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(action.activeMenu('eventinventory'));
    getProject();
  }, []);

  useEffect(() => {
    console.log('Project-Id', projectId, unitNo);
    let LiveEventRoute = sessionStorage.getItem('isEventLive');
    console.log('LiveEventRoute', LiveEventRoute);
    if (LiveEventRoute === 'true') {
      setLiveButton(true);
    }
  }, [projectId]);

  useEffect(() => {
    defineChipColor();
  }, [Units?.inventoryStatusId?.status]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  function defineChipColor() {
    let obj = {};
    if (Units?.inventoryStatusId?.status === 'Available') {
      obj.chipColor = '#027A48';
      obj.chipBackgroundColor = '#D1FADF';
    } else if (Units?.inventoryStatusId?.status === 'On Hold') {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FEF0C7';
    } else if (Units?.inventoryStatusId?.status === 'Payment Pending') {
      obj.chipColor = '#B42318';
      obj.chipBackgroundColor = '#FEE4E2';
    } else if (Units?.inventoryStatusId?.status === 'Reserved') {
      obj.chipColor = '#6941C6';
      obj.chipBackgroundColor = '#F4EBFF';
    } else if (Units?.inventoryStatusId?.status === 'Locked') {
      obj.chipColor = '#344054';
      obj.chipBackgroundColor = '#F2F4F7';
    } else if (Units?.inventoryStatusId?.status === 'Preselected') {
      obj.chipColor = '#FF4405';
      obj.chipBackgroundColor = '#FFE6D5';
    } else if (Units?.inventoryStatusId?.status === 'Kyc Pending') {
      obj.chipColor = '#0E7090';
      obj.chipBackgroundColor = '#ECFDFF';
    } else if (Units?.inventoryStatusId?.status === 'Kyc Done') {
      obj.chipColor = '#0E7090';
      obj.chipBackgroundColor = '#ECFDFF';
    } else if (Units?.inventoryStatusId?.status === 'SDR Payment Pending') {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FFFAEB';
    }
    setChipStyle(obj);
  }

  function getProject() {
    getProjectByProjectName(projectId)
      .then((resp) => {
        console.log('Projects', resp);
        setProjectData(resp.data[0]);
        getUnitByUnitNo(unitNo)
          .then((res) => {
            console.log('Units', res.data[0]);
            if (res.data[0].inventoryStatusId.status !== 'Available') {
              res.data[0].leadId.AllotmentPayment.forEach((lead) => {
                if (lead.leadId === res.data[0].leadId.leadId) {
                  setSalesPersonName(lead?.userId?.name);
                }
              });
            }

            getAllPricingPlansByLaunch(projectId, wingName)
              .then((response67) => {
                console.log('ShowBasePrice', response67);
                let filteredData = response67.data.filter(
                  ({ projectPricingId }) => projectPricingId !== null
                );
                console.log('filteredData', filteredData.length);
                if (resp.data[0]?.useCsvPrice === false) {
                  if (filteredData.length > 0) {
                    console.log('***', filteredData);
                    console.log('for - project - pricing');
                    filteredData[0]?.projectPricingId?.basePrices?.forEach(
                      (_Item) => {
                        if (
                          res.data[0]?.inventoryTypeId?.inventoryTypeId ===
                          _Item.inventoryTypeId
                        ) {
                          setTotalBsp(_Item);
                          if (
                            filteredData[0]?.projectPricingId?.floorRise[0]
                              ?.value
                          ) {
                            filteredData[0]?.projectPricingId?.floorRise?.forEach(
                              (item) => {
                                if (
                                  item.from <= res.data[0]?.floorNo &&
                                  item.to >= res.data[0]?.floorNo
                                ) {
                                  if (item.type === 'Percentage') {
                                    if (
                                      res.data[0]?.saleableArea === _Item.sqft
                                    ) {
                                      const floorRise_per_unit =
                                        (parseInt(_Item.BSPTotal) *
                                          parseInt(item.value)) /
                                        100;

                                      setFloorRiseValue(floorRise_per_unit);
                                    }
                                  } else if (item.type === 'Value') {
                                    const floorRise_per_unit_by_Value =
                                      parseInt(item.value);

                                    setFloorRiseValue(
                                      floorRise_per_unit_by_Value
                                    );
                                  }
                                }
                              }
                            );
                          }

                          if (filteredData[0]?.projectPricingId?.plc) {
                            filteredData[0]?.projectPricingId?.plc.forEach(
                              (item) => {
                                if (res.data[0].view === '') {
                                  if (item.type === 'Percentage') {
                                    if (
                                      res.data[0].saleableArea === _Item.sqft
                                    ) {
                                      const plc_per_unit =
                                        (parseInt(_Item.BSPTotal) *
                                          parseInt(item.value)) /
                                        100;

                                      setPlcValue(plc_per_unit);
                                    }
                                  } else if (item.type === 'Value') {
                                    const plc_per_unit_by_Value = parseInt(
                                      item.value
                                    );
                                    setPlcValue(plc_per_unit_by_Value);
                                  }
                                }
                              }
                            );
                          }
                        }
                      }
                    );
                  } else {
                    setPriceNotAdded(true);
                  }
                } else if (resp.data[0]?.useCsvPrice === true) {
                  console.log('line -178', res.data[0].BSP);
                  setCsvFlag(true);
                  setCsvData(res.data[0]);
                  if (
                    res.data[0].BSP === null ||
                    (res.data[0].BSP === 0 &&
                      res.data[0].GST === 0 &&
                      res.data[0].SDR === 0)
                  ) {
                    setPriceNotAdded(true);
                    if (
                      res.data[0].BSP === 0 &&
                      res.data[0].GST === 0 &&
                      res.data[0].SDR === 0
                    ) {
                      setAfterCancelUnitPrice(true);
                    }
                  }
                } else {
                  setPriceNotAdded(true);
                }
              })
              .catch((err) => {
                console.error('getAllPricingPlansByLaunch', err);
              });
            if (res?.data[0]?.inventoryMergeId) {
              setMergeIdData(true);
              setMergeID(res?.data[0]?.inventoryMergeId?.inventoryMergeId);
              setUnit1(res?.data[0]?.inventoryMergeId?.unit1Id);
              setUnit2(res?.data[0]?.inventoryMergeId?.unit2Id);
            }
            setUnits(res.data[0]);
          })
          .catch((err) => {
            console.error('Units', err);
          });
      })
      .catch((err) => {
        console.error('Projects', err);
      });

    getWingsIdByWingName(wingName)
      .then((response) => {
        console.log('Wings', response);
        setAllWings(response.data[0]);
      })
      .catch((err) => {
        console.error('Wings', err);
      });
  }

  function UnitStatusUpdate(respValue) {
    console.log('respValue', respValue);
    if (respValue === true) {
      getProject();
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  function RouteForAllotment() {
    navigate(
      `/home/Event/Details/${eventID}/DirectAllotment/${launchId}/${projectId}/${wingName}/${unitNo}`
    );
  }

  return (
    <>
      <Box className={cssClasses.Container}>
        <Box className={cssClasses.HeaderTitle}>{ProjectData?.projectName}</Box>
        <Box className={cssClasses.SubTitle} mb={'1rem'} mt={'1rem'}>
          {ProjectData?.addressLine1} , {ProjectData?.addressLine2} ,{' '}
          {ProjectData?.addressLine3}
        </Box>

        <Divider />
        <Box className={cssClasses.BoxDiv}>
          <Box className={cssClasses.NumberTitle}>
            Unit :
            {mergeIdData && Units?.inventoryMergeId?.unit1No
              ? Units?.inventoryMergeId.unit1No <
                Units?.inventoryMergeId.unit2No
                ? `${Units?.inventoryMergeId?.unit1No} ,
             ${Units?.inventoryMergeId?.unit2No}`
                : `${Units?.inventoryMergeId?.unit2No} ,
             ${Units?.inventoryMergeId?.unit1No}`
              : Units?.unitNo}
            <Box component={'span'} className={cssClasses.Title}>
              {' '}
              {ProjectData?.displayInventoryType?.includes('Inventory Type') ? (
                <span>|{Units?.inventoryTypeId?.type}</span>
              ) : (
                ''
              )}
              {ProjectData?.displayInventoryType?.includes(
                'Display Unit Type'
              ) && Units?.displayUnitType !== null ? (
                <span>{'(' + Units?.displayUnitType + ')'}</span>
              ) : (
                ''
              )}
              | {Units?.saleableArea} sq.ft.
            </Box>
          </Box>

          <Box className={cssClasses.Title}>
            Wing :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {/* {AllWings?.wingName} */}
              {AllWings?.displayName ? AllWings?.displayName : AllWings?.wingName}
            </Box>{' '}
          </Box>
          <Box className={cssClasses.Title}>
            Floor :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {Units?.floorNo}
            </Box>{' '}
          </Box>

          <Box className={cssClasses.flexRow}>
            <LeadStatusChip
              style={{
                color: ChipStyle?.chipColor,
                backgroundColor: ChipStyle?.chipBackgroundColor,
              }}
              label={Units?.inventoryStatusId?.status}
              icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
            />
          </Box>

          {PriceNotAdded ? (
            ''
          ) : (
            <Box className={cssClasses.Title}>
              {csvFlag ? (
                <Box
                  component={'span'}
                  ml={1}
                  className={cssClasses.NumberTitle}
                >
                  ₹{' '}
                  {mergeIdData && CsvData?.totalCost
                    ? numberWithCommas(
                        (
                          parseFloat(CsvData?.totalCost) +
                          parseFloat(CsvData?.totalCost)
                        )
                      )
                    : numberWithCommas(
                        (
                          parseFloat(CsvData?.totalCost)
                        )
                      )}
                </Box>
              ) : (
                <Box
                  component={'span'}
                  ml={1}
                  className={cssClasses.NumberTitle}
                >
                  ₹{' '}
                  {mergeIdData && TotalBsp?.BSPTotal
                    ? numberWithCommas(
                        (
                          parseFloat(TotalBsp?.BSPTotal) +
                          parseFloat(TotalBsp?.BSPTotal) +
                          parseFloat(TotalBsp?.REG) +
                          parseFloat(TotalBsp?.GST) +
                          parseFloat(TotalBsp?.GST) +
                          FloorRiseValue
                        ).toFixed(2)
                      )
                    : numberWithCommas(
                        (
                          parseFloat(TotalBsp?.BSPTotal) +
                          parseFloat(TotalBsp?.REG) +
                          parseFloat(TotalBsp?.GST) +
                          FloorRiseValue
                        ).toFixed(2)
                      )}
                </Box>
              )}
            </Box>
          )}
        </Box>

        <Box className={cssClasses.flexRow2} margin={'5rem 0'}>
          <Box className={cssClasses.flexRow2}>
            <Box width={'15rem'}>
              <img src={UnitIcon} alt={''} height={'100%'} width={'100%'} />
            </Box>
            <Box className={cssClasses.unitDetails}>
              <Box className={cssClasses.flexRow2} width={'50%!important'}>
                <Box margin={'0rem 2rem'}>
                  <Box className={cssClasses.LeadInfo}>Price Details:</Box>
                  {PriceNotAdded ? (
                    <Box display={'flex'} flexDirection={'row'}>
                      <LeadStatusChip
                        style={{
                          color: '#000000',
                          backgroundColor: '#ececec',
                        }}
                        label={'Price not Added!'}
                        icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
                      />
                      {afterCancelUnitPrice && (
                        <Box mt={0.2} ml={1}>
                          <InfoOutlinedIcon
                            onClick={handleClick}
                            style={{
                              width: '2rem',
                              height: '2rem',
                              color: '#344054',
                            }}
                          ></InfoOutlinedIcon>
                          <Popover
                            id={id}
                            open={IconOpen}
                            anchorEl={anchorEl}
                            onClose={handleIconClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                          >
                            <Typography
                              style={{ fontSize: '1.4rem' }}
                              sx={{ p: 2 }}
                            >
                              Unit is recently cancelled.Reprice is pending
                            </Typography>
                          </Popover>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Box className={cssClasses.unitPriceWrap}>
                      <Box className={cssClasses.Title}>
                        Agreement Value:{' '}
                        {csvFlag ? (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {mergeIdData && CsvData?.BSP
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(CsvData?.BSP) +
                                    parseFloat(CsvData?.BSP)
                                )}`
                              : ` ₹ ${numberWithCommas(CsvData?.BSP)}`}
                          </Box>
                        ) : (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {mergeIdData && TotalBsp?.BSPTotal
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(TotalBsp?.BSPTotal) +
                                    parseFloat(TotalBsp?.BSPTotal)
                                )}`
                              : ` ₹ ${numberWithCommas(TotalBsp?.BSPTotal)}`}
                          </Box>
                        )}
                      </Box>
                      <Box className={cssClasses.Title}>
                        GST :{' '}
                        {csvFlag ? (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {mergeIdData && CsvData.GST
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(CsvData.GST) +
                                    parseFloat(CsvData.GST)
                                )}`
                              : ` ₹ ${numberWithCommas(+CsvData.GST)}`}
                          </Box>
                        ) : (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {mergeIdData && TotalBsp.GST
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(TotalBsp.GST) +
                                    parseFloat(TotalBsp.GST)
                                )}`
                              : ` ₹ ${numberWithCommas(+TotalBsp.GST)}`}
                          </Box>
                        )}
                      </Box>
                      {csvFlag ? (
                        <Box className={cssClasses.Title}>
                          SDR :{' '}
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {CsvData?.SDR
                              ? ` ₹ ${numberWithCommas(CsvData?.SDR)}`
                              : '-'}
                          </Box>
                        </Box>
                      ) : (
                        <Box className={cssClasses.Title}>
                          SDR :{' '}
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            {TotalBsp?.SDR
                              ? ` ₹ ${numberWithCommas(TotalBsp?.SDR)}`
                              : '-'}
                          </Box>
                        </Box>
                      )}

                      {csvFlag === false && (
                        <Box className={cssClasses.Title}>
                          FloorRise :{' '}
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            ₹
                            {FloorRiseValue
                              ? numberWithCommas(FloorRiseValue)
                              : '-'}
                          </Box>
                        </Box>
                      )}
                      <Box className={cssClasses.Title}>
                        Total :{' '}
                        {csvFlag ? (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            ₹{' '}
                            {mergeIdData && CsvData?.totalCost
                              ? numberWithCommas(
                                  (
                                    parseFloat(CsvData?.totalCost) +
                                    parseFloat(CsvData?.totalCost)
                                  )
                                )
                              : numberWithCommas(
                                  (
                                    parseFloat(CsvData?.totalCost)
                                  )
                                )}
                          </Box>
                        ) : (
                          <Box
                            component={'span'}
                            ml={1}
                            className={cssClasses.NumberTitle}
                          >
                            ₹{' '}
                            {mergeIdData && TotalBsp.Total
                              ? numberWithCommas(
                                  (
                                    parseFloat(TotalBsp.Total) +
                                    parseFloat(TotalBsp.Total) 
                                    // +
                                    // FloorRiseValue
                                  ).toFixed(2)
                                )
                              : numberWithCommas(
                                  (
                                    (parseFloat(TotalBsp?.Total)
                                      ? parseFloat(TotalBsp?.Total)
                                      : 0) 
                                    //   +
                                    // (FloorRiseValue ? FloorRiseValue : 0)
                                  ).toFixed(2)
                                )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
              {(Units?.inventoryStatusId?.status ||
                Units?.inventoryStatusId?.status === 'On Hold' ||
                Units?.inventoryStatusId?.status === 'Payment Pending') && (
                <>
                  <Box width={'50%!important'}>
                    <Box className={cssClasses.LeadInfo}>Lead Info:</Box>
                    <Box className={cssClasses.unitPriceWrap}>
                      <Box className={cssClasses.Title}>
                        Lead Name :{' '}
                        <Box
                          component={'span'}
                          ml={1}
                          className={cssClasses.NumberTitle}
                        >
                          {Units?.leadId?.personId?.name
                            ? Units?.leadId?.personId?.name
                            : '-'}
                        </Box>{' '}
                      </Box>
                      <Box className={cssClasses.Title}>
                        Lead ID:{' '}
                        <Box
                          component={'span'}
                          ml={1}
                          className={cssClasses.NumberTitle}
                        >
                          {Units?.leadId?.leadDisplayId
                            ? 'VJ' +
                              Units?.leadId?.leadDisplayId.replace(
                                Units?.leadId?.leadDisplayId.substring(8, 12),
                                '-' +
                                  Units?.leadId?.leadDisplayId.substring(8, 12)
                              )
                            : '-'}
                        </Box>
                      </Box>
                      {loggedInUser.roleId.level === 1 && (
                        <>
                          <Box className={cssClasses.Title}>
                            Lead Contact No :{' '}
                            <Box
                              component={'span'}
                              ml={1}
                              className={cssClasses.NumberTitle}
                            >
                              {Units?.leadId?.personId?.contactNumber
                                ? '+' + Units?.leadId?.personId?.contactNumber
                                : '-'}
                            </Box>
                          </Box>

                          <Box className={cssClasses.Title}>
                            Lead Email Id :{' '}
                            <Box
                              component={'span'}
                              ml={1}
                              className={cssClasses.NumberTitle}
                            >
                              {Units?.leadId?.personId?.email
                                ? Units?.leadId?.personId?.email
                                : '-'}
                            </Box>
                          </Box>
                        </>
                      )}

                      <Box className={cssClasses.Title}>
                        SM :{' '}
                        <Box
                          component={'span'}
                          ml={1}
                          className={cssClasses.NumberTitle}
                        >
                          {SalesPersonName ? SalesPersonName : '-'}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>

        <Box height={'20rem'}></Box>
      </Box>

      {Units &&
        Units.inventoryStatusId?.status === 'Available' &&
        liveButton === true && (
          <>
            <Box className={cssClasses.footerDiv}>
              <Box className={cssClasses.RightButtonWrap} ml={'auto'}>
                <Button
                  style={{
                    color: '#fff',
                    backgroundColor: '#1570EF',
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    fontFamily: 'Roboto-Regular',
                  }}
                  padding={'0.8rem 2.6rem'}
                  btnName={'Alot'}
                  clicked={() => RouteForAllotment()}
                />
              </Box>
            </Box>
          </>
        )}
    </>
  );
}

export default EventUnitDetails;
